import isEmpty from 'lodash/isEmpty';
import isEmail from 'validator/lib/isEmail';

export const validate = email => {

    if (isEmpty(email)) {
        return 'Votre e-mail est nécessaire pour vous envoyer le lien';
    }

    if (!isEmail(email)) {
        return 'Cette adresse e-mail ne semble pas valide';
    }

    return null;
};

